export type NewsItem = {
  id: string;
  title: string;
  summary: string;
  category: string;
  date: string;
  image: string;
  relatedId: string;
};

export const newsList: NewsItem[] = [
  {
    id: "n-001",
    title: "《长夜将明》收官评分 9.3，刑侦剧的叙事密度还能更高吗",
    summary: "24 集完整落幕后，观众讨论的焦点从“凶手是谁”转向了“每一个人为什么这么做”。",
    category: "剧集观察",
    date: "2025-10-16",
    image:
      "https://readdy.ai/api/search-image?query=Rainy%20city%20night%20with%20orange%20street%20lamps%20reflected%20on%20asphalt%2C%20lone%20umbrella%20silhouette%2C%20moody%20cinematic%20crime%20drama%20still%2C%20deep%20navy%20tones&width=800&height=500&seq=97v-news-001&orientation=landscape",
    relatedId: "t-001",
  },
  {
    id: "n-002",
    title: "《山海画卷》幕后：一帧水墨是怎么动起来的",
    summary: "团队用两年时间把传统水墨的“留白”变成可运动的分镜语言，全片共绘制超过十一万张原画。",
    category: "幕后",
    date: "2025-10-14",
    image:
      "https://readdy.ai/api/search-image?query=Ink%20wash%20mountain%20landscape%20with%20golden%20clouds%20and%20a%20tiny%20bridge%2C%20traditional%20Chinese%20painting%20meets%20cinematic%20animation%20background%2C%20navy%20and%20gold&width=800&height=500&seq=97v-news-002&orientation=landscape",
    relatedId: "m-003",
  },
  {
    id: "n-003",
    title: "本周新片：三部类型片同日上线，悬疑赛道最拥挤",
    summary: "《影宅谜局》《深海回声》与《第二十三层》扎堆更新，影迷们的周末安排已经排满了。",
    category: "新片速递",
    date: "2025-10-13",
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20cinema%20interior%20with%20red%20seats%20and%20a%20glowing%20projector%20beam%20through%20dust%2C%20warm%20amber%20and%20deep%20maroon%20tones%2C%20cinematic&width=800&height=500&seq=97v-news-003&orientation=landscape",
    relatedId: "m-009",
  },
  {
    id: "n-004",
    title: "《深夜放映室》第 36 期：当一部老电影被重新修复",
    summary: "本期嘉宾带来一卷 1978 年的胶片，聊聊修复一部电影到底是在修复什么。",
    category: "访谈",
    date: "2025-10-17",
    image:
      "https://readdy.ai/api/search-image?query=Intimate%20late-night%20talk%20show%20studio%20with%20two%20armchairs%20and%20a%20warm%20spotlight%2C%20dark%20navy%20curtains%2C%20cinematic%20television%20set%20photography&width=800&height=500&seq=97v-news-004&orientation=landscape",
    relatedId: "v-001",
  },
  {
    id: "n-005",
    title: "《潮汐之城》为什么值得一口气看完 32 集",
    summary: "它没有强情节，却把一座港口城市的十年变化，装进了三代人的日常选择里。",
    category: "剧集观察",
    date: "2025-10-11",
    image:
      "https://readdy.ai/api/search-image?query=Harbor%20city%20skyline%20at%20dusk%20with%20cargo%20ships%20and%20warm%20window%20lights%2C%20calm%20water%20reflections%2C%20peach%20and%20navy%20cinematic%20urban%20tones&width=800&height=500&seq=97v-news-005&orientation=landscape",
    relatedId: "t-002",
  },
  {
    id: "n-006",
    title: "露营综艺的第二春：观众想看的不是挑战，是松弛",
    summary: "《一起露营吧》新一期收视上扬，慢综艺正在用“什么都没发生”重新赢得注意力。",
    category: "综艺",
    date: "2025-10-09",
    image:
      "https://readdy.ai/api/search-image?query=Lakeside%20campsite%20at%20dusk%20with%20a%20glowing%20tent%20and%20campfire%2C%20mountains%20and%20stars%2C%20warm%20amber%20light%20and%20deep%20blue%20sky%2C%20cinematic%20outdoor%20photography&width=800&height=500&seq=97v-news-006&orientation=landscape",
    relatedId: "v-002",
  },
];